import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import Table from '../components/table/main';
import Search from  '../../shared/search/main';
import Filters from '../../shared/filters/main';
import Calendar from '../../shared/calendar/main';
import { selectors as rootSelectors } from '../../root';
import SwitchControlMulti from '../../shared/switch-control/multi/main';
import Switch from '../../shared/switch-routes/main';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content affiliates-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Switch
							intl={props.intl}
							places={[{ name: 'affiliates', title: `Affiliates (${props.online})` }]}
						/>
					</div>
				</div>
				<div className="container__content-body">
					{
						props.can('view') &&
						<div className="affiliates-list__filter-position clearfix">
							<Filters {...props} {...props.filters} />
						</div>
					}

					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---search">
							<div className="ui-control-bar__item-position">
								<Search
									{...props}
									form="affiliatesSearchForm"
									action={props.search}
									autoFocus={true}
									initialValues={props.searchData} />
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<SwitchControlMulti
									intl={props.intl}
									filters={props.switchControlMultiItems}
									choose={filterValue => {
										props.switchControlMultiChooseFilter(filterValue);
										props.apply();
									}}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position affiliates-list__buttons">
								<button className="ui-btn ui-btn-primary apply" type="submit" onClick={props.apply}>
									{props.intl('Apply')}
								</button>
								{props.can('download') && (
									<button
										className="ui-btn ui-btn-primary apply"
										type="submit"
										disabled={
											isRocket && !get(props.filters.selectedFilters.find((f) => f.name === 'geos'), 'value.length')
										}
										onClick={isRocket ? props.export : props.download}
									>
										{isRocket ? props.intl('Export') : props.intl('Download')}
									</button>
								)}
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<Table
						{...props}
						isIndexing
						narrow
					/>
				</div>
			</div>
		</Animate>
);

export default connect(
	state => ({
		online: selectors.getOnlineCount(state),
		data: selectors.getData(state),
		table: selectors.getTable(state),
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state),
		searchData: selectors.getSearchData(state),
		availableCurrencies: selectors.getAvailableCurrencies(state),
		pagination: selectors.getPagination(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		switchControlMultiItems: selectors.getSwitchControlMultiItems(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/list/main.js